import WinnerItem from "./WinnerItem";

export default WinnerItem;
